import Tooltip from "components/Tooltip/smallerTooltip"
import React from "react"
import { classNames } from "./../../utils/classNames"

const Step = ({ className, title, color, description, index }) => {
  return (
    <Tooltip text={title}>
      <div
        style={{
          backgroundColor: `${color}`,
          zIndex: `${2 - index}`,
        }}
        className={classNames(className, "relative")}
      >
        <span className="text-[#323232] text-center font-normal 2xl:text-[13px] xl:text-[11px] absolute top-4 w-full hover:text-[#3399FF]">
          {description}
        </span>
      </div>
    </Tooltip>
  )
}

export default Step
